import styled from 'styled-components';
import { palette } from 'styled-tools';

import {
	Button,
	fontSize,
	FontSizes,
	fontWeight,
	FontWeights,
	minWidth,
	OptionalBackgroundButtonProps,
	units,
} from '@calm-web/design-system';

import { ContentWrapper } from '@/components/b2b/shared/styles';

export const WelcomeText = styled.h1<{ compact?: boolean }>`
	font-size: ${units(2.25)};
	${fontWeight(FontWeights.Demi)}
	margin: 0;
	width: 100%;
	max-width: 288px;
	line-height: 150%;
	color: ${palette('gray7')};

	${minWidth('mobileLarge')} {
		font-size: ${units(2.25)};
	}

	${minWidth('tablet')} {
		max-width: 480px;
		margin-bottom: 0;
		${fontWeight(FontWeights.Medium)};
		${fontSize(FontSizes.lg)}
	}

	${minWidth('desktop')} {
		margin: 0;
	}
`;

export const BlueLine = styled.div`
	width: 100%;
	height: 1px;
	background-color: ${palette('buttonBlue')};
	margin: ${units(4)} auto;

	${minWidth('tablet')} {
		margin: ${units(3.56)} 0;
	}
`;

export const AccountText = styled.div`
	${fontSize(FontSizes.base)}
	margin-bottom: ${units(4)};
	${fontWeight(FontWeights.Regular)}
	line-height: 150%;
	color: ${palette('gray7')};

	p {
		margin-bottom: 24px;
	}

	${minWidth('tablet')} {
		margin-bottom: ${units(3.56)};
	}
`;

export const ButtonWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;

	${minWidth('tablet')} {
		flex-direction: row;
	}
`;

export const Link = styled.a`
	color: #696969;
	text-decoration: underline;
`;

const StyledWelcomeButton = styled(Button)`
	color: ${palette('gray6')};
	border: 2px solid ${palette('gray6')};
	text-transform: unset;
	justify-content: flex-start;
	${fontWeight(FontWeights.Demi)}
	width: 100%;
	height: 52px;
	font-size: ${units(2.25)};
	line-height: 150%;

	&:first-of-type {
		margin-right: 0;
		margin-bottom: ${units(1.5)};
	}

	${minWidth('tablet')} {
		${fontSize(FontSizes.base)}

		&:first-of-type {
			margin-right: ${units(1.33)};
		}
	}
`;

export const D2CToSText = styled.div`
	${fontSize(FontSizes.base)};
	margin-top: 24px;
	margin-bottom: 24px;
`;

export const WelcomeButton = ({ backgroundColor, ...restProps }: OptionalBackgroundButtonProps) => (
	<StyledWelcomeButton {...restProps} backgroundColor={backgroundColor || 'white'} />
);

export const WelcomeSignUpButton = styled(Button)`
	height: 52px;
	${fontWeight(FontWeights.Demi)};
	font-size: ${units(2.25)};
	line-height: 150%;

	${minWidth('tablet')} {
		${fontSize(FontSizes.base)};
	}
`;

export const WelcomeContentWrapper = styled(ContentWrapper)`
	${minWidth('tablet')} {
		padding: ${units(10.67)} ${units(4.44)};
	}
`;
